import { baseFetch } from "./base";

export interface QuizFeedbackData {
  question_text: string;
  question_competency: string;
  question_language: string;
  all_answers: Array<{ text: string; points: number }>;
  user_selected_answer?: string;
  correct_answer?: string;
  quiz_index: number;
  total_questions: number;
  domain: string;
  focus: string;
}

interface FeedbackData {
  input?: string;
  rating?: number;
  rating_label?: string;
  reason?: string;
  reason_label?: string;
  feedback_details?: {
    wrong_info?: string;
    correction?: string;
    source?: string;
    missing_info?: string;
    priority?: string;
    source_to_include?: string;
    unclear_part?: string;
    suggested_phrase?: string;
    preferred_format?: string;
    why_irrelevant?: string;
    should_address?: string;
    specificity_needed?: string;
    example_answer?: string;
  };
  selected_stars?: number;
  feedback_type?: "message" | "quiz_question";
  quiz_data?: QuizFeedbackData;
  message_id?: string;
  message_text?: string;
  message_type?: string;
  domain?: string;
  focus?: string;
  user_id?: string;
  date?: string;
  quiz_details?: {
    buttons?: Array<{
      text: string;
      isCorrect?: boolean;
    }>;
    total_buttons?: number;
    is_multiple_choice?: boolean;
    has_navigation?: boolean;
  };
  full_message_data?: string;
  previous_user_message_data?: string;
  file?: File;
}

export const sendFeedback = async (data: FeedbackData) => {
  const hasRating =
    typeof data.rating === "number" && data.rating >= 0 && data.rating <= 5;
  const hasSelectedStars =
    typeof data.selected_stars === "number" && data.selected_stars > 0;

  if (!hasRating && !hasSelectedStars) {
    const error = new Error(
      "Rating or selected_stars must be provided and valid"
    );
    console.error("=== VALIDATION ERROR ===");
    console.error("Error while sending feedback:", error.message);
    throw error;
  }

  try {
    const { file, ...payload } = data;
    const formData = new FormData();
    formData.append("data", JSON.stringify(payload));

    if (file) {
      formData.append("file", file);
    }

    const response = await baseFetch.post("/feedback", formData, {
      headers: {
        // Override axios instance default JSON content-type for FormData requests.
        "Content-Type": undefined,
      },
    });

    return response.data;
  } catch (error: unknown) {
    console.error("=== AXIOS ERROR ===");
    if (error instanceof Error) {
      console.error("Error while sending feedback:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};
